"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.MediaCacheWebBuilder = exports.MediaCacheWeb = void 0;
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var CommonLogic_1 = require("./CommonLogic");
var MediaCacheWeb = /** @class */ (function () {
    function MediaCacheWeb(medias) {
        this.inMemoryCache = new Map();
        // for (const m of medias) {
        //   if (!m.url || !m.contentBase64)
        //     throw new Exception(
        //       `Cannot use media to initialise asset stire because it lacks url or base64 content`
        //     );
        //   this.inMemoryCache.set(m.url!, m.contentBase64!);
        // }
    }
    MediaCacheWeb.prototype.hasUrlStoredLocally = function (url) {
        return this.inMemoryCache.has(url);
    };
    MediaCacheWeb.prototype.getFromUrl = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var mimeType, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mimeType = core_common_domain_1.ContentType.filenameToMimeType(CommonLogic_1.CommonLogic.filenameOfUrl(url));
                        if (mimeType === undefined)
                            throw new core_common_domain_1.Exception("Cannot retrieve resource from url " + url + " because the filename has an unrecognised extension. Fix the file extension or add a new valid mime type in the system.");
                        return [4 /*yield*/, CommonLogic_1.CommonLogic.retrieveUrlContent(url)];
                    case 1:
                        result = _a.sent();
                        if (!result.success) {
                            throw new core_common_domain_1.Exception("Fetching url " + url + " failed.");
                        }
                        if (result.content.byteLength === 0)
                            throw new core_common_domain_1.Exception("Cannot retrieve resource from url " + url + " because the returned content is empty.");
                        return [2 /*return*/, {
                                mimeType: mimeType,
                                data: result.content
                            }];
                }
            });
        });
    };
    return MediaCacheWeb;
}());
exports.MediaCacheWeb = MediaCacheWeb;
var MediaCacheWebBuilder = /** @class */ (function () {
    function MediaCacheWebBuilder(mediaCache) {
        this.mediaCache = mediaCache;
    }
    MediaCacheWebBuilder.initialiseEmpty = function () {
        return new MediaCacheWebBuilder(new MediaCacheWeb([]));
    };
    MediaCacheWebBuilder.initialiseWithMedias = function (medias) {
        return new MediaCacheWebBuilder(new MediaCacheWeb(medias));
    };
    MediaCacheWebBuilder.prototype.build = function () {
        return this.mediaCache;
    };
    return MediaCacheWebBuilder;
}());
exports.MediaCacheWebBuilder = MediaCacheWebBuilder;
